var exports = {
  "kL": "xae11d333--eeebb9--container",
  "Xq": "xae11d333--eeebb9--card-image",
  "Gh": "xae11d333--eeebb9--logo-url",
  "KX": "xae11d333--eeebb9--text-content",
  "Pf": "xae11d333--eeebb9--label",
};

module.exports = exports;
